import React from "react";
import { Link } from "react-router-dom";
import { Home, ChevronRight } from "lucide-react";

// "🏠 > DASHBOARD > JOURNEYS > ..." breadcrumb used on TSP inner pages.
// `items` entries are either a plain string (unlinked) or { label, to } (a
// link). The last entry renders as the active crumb and is never linked.
export default function TspBreadcrumb({ items }) {
  return (
    <nav className="tsp-breadcrumb" aria-label="Breadcrumb">
      <Link to="/tsp" className="tsp-breadcrumb-home" aria-label="TSP dashboard">
        <Home size={14} />
      </Link>
      {items.map((item, index) => {
        const label = typeof item === "string" ? item : item.label;
        const to = typeof item === "string" ? null : item.to;
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={`${index}-${label}`}>
            <ChevronRight size={13} className="tsp-breadcrumb-sep" aria-hidden="true" />
            {to && !isLast ? (
              <Link to={to} className="tsp-breadcrumb-link">
                {label.toUpperCase()}
              </Link>
            ) : (
              <span className={isLast ? "tsp-breadcrumb-active" : ""} aria-current={isLast ? "page" : undefined}>
                {label.toUpperCase()}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
